import { useEffect } from "react";
import { App as CapacitorApp } from "@capacitor/app";
import { Capacitor } from "@capacitor/core";
import { useNavigate } from "react-router-dom";
import { addQaPushTapListener } from "../features/notifications/qaPush.js";
import { addNativeTestPushTapListener } from "../features/notifications/nativePushTest.js";

const NATIVE_APP_ORIGIN = "https://app.axonleads.ru";
const AUTH_CALLBACK_PATHS = new Set(["/auth/finish", "/auth/vk/callback"]);

export function trustedNativeCallbackPath(value) {
  try {
    const url = new URL(value);
    if (url.origin !== NATIVE_APP_ORIGIN || !AUTH_CALLBACK_PATHS.has(url.pathname)) {
      return null;
    }
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return null;
  }
}

export function NativeUrlListener() {
  const navigate = useNavigate();

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return undefined;

    let active = true;
    let listenerHandle;
    let pushHandle;
    let nativeTestPushHandle;
    const open = (value) => {
      const path = trustedNativeCallbackPath(value);
      if (active && path) navigate(path, { replace: true });
    };

    void CapacitorApp.getLaunchUrl().then((launch) => open(launch?.url)).catch(() => {});
    void CapacitorApp.addListener("appUrlOpen", ({ url }) => open(url)).then((handle) => {
      if (!active) void handle.remove();
      else listenerHandle = handle;
    }).catch(() => {});
    void addQaPushTapListener((path) => {
      if (active) navigate(path);
    }).then((handle) => {
      if (!active) void handle?.remove();
      else pushHandle = handle;
    }).catch(() => {});
    void addNativeTestPushTapListener((path) => {
      if (active) navigate(path);
    }).then((handle) => {
      if (!active) void handle?.remove();
      else nativeTestPushHandle = handle;
    }).catch(() => {});

    return () => {
      active = false;
      if (listenerHandle) void listenerHandle.remove();
      if (pushHandle) void pushHandle.remove();
      if (nativeTestPushHandle) void nativeTestPushHandle.remove();
    };
  }, [navigate]);

  return null;
}
